const descriptionTexts = (content,language) => {
    return Object.keys(content)
      .filter(key => key.includes("Description_text_"))
      .map(key => content[key][language]);
};

export default descriptionTexts;